import { useState } from 'react'
import { toast } from 'sonner'
import { useMaintenanceWindows, useCreateMw, useDeleteMw } from '@/lib/alerts'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Skeleton } from '@/components/ui/skeleton'

export function MaintenanceWindowsPage() {
  const { data, isLoading } = useMaintenanceWindows()
  const createMut = useCreateMw()
  const deleteMut = useDeleteMw()

  const [name, setName] = useState('')
  const [startsAt, setStartsAt] = useState('')
  const [endsAt, setEndsAt] = useState('')

  async function handleCreate() {
    if (!name || !startsAt || !endsAt) {
      toast.error('All fields are required')
      return
    }
    try {
      await createMut.mutateAsync({ name, starts_at: new Date(startsAt).toISOString(), ends_at: new Date(endsAt).toISOString() })
      toast.success('Maintenance window created')
      setName('')
      setStartsAt('')
      setEndsAt('')
    } catch (e) {
      toast.error(e instanceof Error ? e.message : 'Create failed')
    }
  }

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold tracking-tight">Maintenance Windows</h1>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Add window</CardTitle>
        </CardHeader>
        <CardContent className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="space-y-1 md:col-span-1">
            <Label htmlFor="mw-name">Name</Label>
            <Input id="mw-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Deploy window" />
          </div>
          <div className="space-y-1">
            <Label htmlFor="mw-starts">Starts at</Label>
            <Input id="mw-starts" type="datetime-local" value={startsAt} onChange={(e) => setStartsAt(e.target.value)} />
          </div>
          <div className="space-y-1">
            <Label htmlFor="mw-ends">Ends at</Label>
            <Input id="mw-ends" type="datetime-local" value={endsAt} onChange={(e) => setEndsAt(e.target.value)} />
          </div>
          <div className="flex items-end">
            <Button onClick={() => void handleCreate()} disabled={createMut.isPending}>
              Create
            </Button>
          </div>
        </CardContent>
      </Card>

      {isLoading && <Skeleton className="h-40" />}

      {data && data.length === 0 && (
        <p className="text-sm text-muted-foreground">No maintenance windows defined.</p>
      )}

      {data && data.map((mw) => (
        <Card key={mw.id}>
          <CardContent className="flex items-center justify-between py-4">
            <div className="space-y-1">
              <p className="font-medium">{mw.name}</p>
              <p className="text-sm text-muted-foreground">
                {new Date(mw.starts_at).toLocaleString()} — {new Date(mw.ends_at).toLocaleString()}
              </p>
            </div>
            <Button
              variant="destructive"
              size="sm"
              disabled={deleteMut.isPending}
              onClick={() =>
                deleteMut.mutate(mw.id, {
                  onSuccess: () => toast.success('Deleted'),
                  onError: (e) => toast.error(e instanceof Error ? e.message : 'Delete failed'),
                })
              }
            >
              Delete
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
